import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { usePagination } from '@/scopes/search/search/domain/hooks'

import { Pagination } from '@sunwebgroup/ui-components/uds'

import * as React from 'react'
import { useIntl } from 'react-intl'

export function SearchPagination() {
  const { currentPage, numberOfPages, setNextPage, setPreviousPage, setPage } = usePagination()
  const { sendEvent } = useAnalytics()
  const intl = useIntl()

  const sendPaginationSearchEvent = (pageNumber: number) => {
    sendEvent({
      event: 'paginationSearch',
      description: 'pagination of product listing',
      element: 'number',
      type: 'result page',
      result: pageNumber,
    })
  }

  const handlePreviousPage = () => {
    sendPaginationSearchEvent(currentPage - 1)
    setPreviousPage()
  }

  const handleNextPage = () => {
    sendPaginationSearchEvent(currentPage + 1)
    setNextPage()
  }

  const handleSetPage = (pageNumber: number | string) => {
    setPage(pageNumber)
  }

  if (numberOfPages <= 1) {
    return null
  }

  return (
    <Pagination
      currentPage={currentPage}
      totalPages={numberOfPages}
      goToNextPage={handleNextPage}
      goToPage={handleSetPage}
      goToPreviousPage={handlePreviousPage}
      previousPageLabel={intl.formatMessage({ id: 'pagination_go_to_previous_page_label' })}
      nextPageLabel={intl.formatMessage({ id: 'pagination_go_to_next_page_label' })}
      pageLabel={(pageNumber: number) => intl.formatMessage({ id: 'pagination_go_to_page_label' }, { pageNumber })}
    />
  )
}
